// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1I8YN","selected":"Chip_selected__103bH"};